<template>
    <b-modal
      v-model="isModalOpen"
      size="lg"
      @hidden="closeModal"
      hide-header
    >
      <modal-job-description 
        :job="jd"
        :highlightedJobTitle="highlightedJobTitle"
      />

      <template #modal-footer>
        <div class="custom-modal-footer">
            <b-button 
            @click="closeModal"
            class="custom-btn"
            >
            閉じる
            </b-button>
        </div>
        </template>
    </b-modal>
  </template>

  <script>
  import ModalJobDescription from './ModalJobDescription.vue';

  export default {
    name: 'JDDetailModal',
    components: {
      ModalJobDescription
    },
    props: {
      jd: {
        type: Object,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      highlightedJobTitle: {
        type: String,
      }
    },
    computed: {
      isModalOpen: {
        get() {
          return this.isOpen;
        },
        set(value) {
          if (!value) {
            this.closeModal();
          }
        }
      }
    },
    methods: {
      closeModal() {
        this.$emit('closeJdModal');
      },
    }
  };
  </script>

  <style scoped>
  ::v-deep .modal-body {
    padding: 0 !important;
  }
  ::v-deep .modal-footer {
    justify-content: center !important;
  }
  .custom-btn {
    border-radius: 8px !important;
    background: #006c6b !important;
  }
  </style>